module.exports = __webpack_public_path__ + "img/rateLev_3.06afc9f8.svg";